import Router from "vue-router";
import store from "@/store";

import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";

import Dashboard from "@/pages/Dashboard.vue";
import UserProfile from "@/pages/UserProfile.vue";
// import TableList from "@/pages/TableList.vue";
// import Typography from "@/pages/Typography.vue";
// import Icons from "@/pages/Icons.vue";
// import Maps from "@/pages/Maps.vue";
// import Notifications from "@/pages/Notifications.vue";
import Login from "@/pages/Login.vue";
import Projects from "@/pages/Projects.vue";
import Project from "@/pages/Project.vue";
import Support from "@/pages/Support.vue";
import Calendar from "@/pages/Calendar.vue";
import Logout from "@/components/Logout.vue";

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/dashboard",
    meta: { requiresAuth: true },
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard
      },
      {
        path: "user",
        name: "User Profile",
        component: UserProfile
      },
      {
        path: "projects",
        name: "Projects",
        component: Projects
      },
      {
        path: "/projects/:id",
        name: "Project details",
        component: Project
      },
      {
        path: "/projects/:id/actuals",
        name: "Project actuals",
        component: Project
      },
      {
        path: "/support",
        name: 'Support',
        component: Support,
      },
      {
        path: "/calendar",
        name: 'Calendar',
        component: Calendar,
      },
      {
        path: '/logout',
        name: 'Logout',
        component: Logout,
      }
    ]
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  }
];

const router = new Router({
  mode: "history",
  routes: routes
});

// Set up global navigation guard
router.beforeEach((to, from, next) => {
  //check if the route requires auth and if the device is connected to the internet
  if (to.matched.some(record => record.meta.requiresAuth) && navigator.onLine) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters.isAuthenticated) {
      next({
        path: "/login",
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }

  // Clear form errors on every page change
  store.commit("clearFormErrors");
});

export default router;
